import type { ReactElement } from 'react';

/** 상세 첫 로드 자리 — 제목 줄·큰 사진 칸을 회색으로 깐다. 안내 문구는 보조 기술에만 읽힌다. */
export const PortfolioDetailSkeleton = (): ReactElement => (
  <div>
    <p role="status" className="sr-only">
      포트폴리오를 불러오는 중입니다.
    </p>
    <div aria-hidden className="flex flex-col">
      <div className="h-4 w-20 bg-muted" />
      <div className="mt-8 h-12 w-2/3 max-w-2xl bg-muted" />
      <div className="mt-10 h-16 w-full border-t border-foreground/10" />
      <div className="mt-6 aspect-[4/3] w-full bg-muted/70 sm:aspect-[16/9]" />
    </div>
  </div>
);
